module.exports = __webpack_public_path__ + "static/media/AddPhoto.b745dbf0.svg";